export interface SettingsCompanyFeedPostsRouter {
  goToNewsDetail(id: string): void;
  goToPostDetail(
    communityId: string,
    communitySlug: string,
    postId: string,
  ): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingsCompanyFeedPostsRouter = Symbol(
  'SettingsCompanyFeedPostsRouter',
);
